/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonBadge from "components/ArgonBadge";

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { Link } from "react-router-dom";

const AllVideosTableData = (videos, handleViewClick, handleDeleteClick, refreshData) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "Title", align: "left" },
    { name: "Video Type", align: "center" },
    { name: "Description", align: "left" },
    { name: "Video Link", align: "left" },
    { name: "Action", align: "center" },
  ],

  rows: videos.map((video, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {index + 1}
      </ArgonTypography>
    ),
    "Title": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {video.title || "N/A"}
      </ArgonTypography>
    ),
    "Video Type": (
      <ArgonBadge 
        variant="gradient" 
        badgeContent={video.videoType || "N/A"} 
        color={video.videoType === "EDUCATIONAL" ? "success" : video.videoType === "TUTORIAL" ? "info" : "warning"}
        size="xs" 
        container 
      />
    ),
    "Description": (
      <ArgonTypography 
        variant="caption" 
        color="text" 
        fontWeight="medium"
        sx={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "200px"
        }}
      >
        {video.description || "N/A"}
      </ArgonTypography>
    ),
    "Video Link": (
      <ArgonTypography 
        variant="caption" 
        color="info" 
        fontWeight="medium"
        sx={{
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "150px"
        }}
      >
        <a href={video.videoLink} target="_blank" rel="noopener noreferrer">
          {video.videoLink || "N/A"}
        </a>
      </ArgonTypography>
    ),
    "Action": (
      <ArgonBox display="flex" alignItems="center" gap={0}>
        {/* View Icon */}
        <ArgonButton 
          variant="text" 
          size="large" 
          sx={{ minWidth: "32px", p: 0 }}
          onClick={() => handleViewClick(video)}
        >
          <VisibilityIcon color="info" />
        </ArgonButton>
        {/* Edit Icon */}
        <ArgonButton 
          variant="text" 
          size="large" 
          component={Link} 
          to={`/allvideos/editvideo/${video._id}`}
          sx={{ minWidth: "32px", p: 0 }}
        >
          <EditIcon color="primary" />
        </ArgonButton>
        {/* Delete Icon */}
        <ArgonButton 
          variant="text" 
          size="large" 
          sx={{ minWidth: "32px", p: 0 }}
          onClick={() => handleDeleteClick(video._id)}
        >
          <DeleteIcon color="error" />
        </ArgonButton>
      </ArgonBox>
    ),
  })),
});

export default AllVideosTableData;
